import { render } from "./create-company.vue?vue&type=template&id=47aa6cc8"
import script from "./create-company.vue?vue&type=script&lang=js"
export * from "./create-company.vue?vue&type=script&lang=js"

import "./create-company.vue?vue&type=style&index=0&id=47aa6cc8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__